// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"627":"cde83840","959":"05a0a968"}[chunkId] + ".chunk.css";
};